import React, { useEffect } from "react";
import PageTitle from "./PageTitle";
import Spacer from "./Spacer";
import "./DemographicsPage.styles.css";
import { getParticipantIdFromSearchParams } from "../utils/urlParams";
import { recordStudyComplete } from "../utils/studyTimingApi";

const INCOMPLETE_TASK_CODE = "INCOMPLETE_XYZ789"; // <-- Replace with your actual incomplete task code

const IncompleteThankYouPage: React.FC = () => {
  const participantId = getParticipantIdFromSearchParams(window.location.search);

  useEffect(() => {
    recordStudyComplete(participantId);
  }, [participantId]);

  return (
    <div className="demographics-bg">
      <div className="demographics-card fade-in">
        <PageTitle title="Thank You!" />
        <Spacer />
        <div className="demographics-thankyou" style={{ fontSize: 20, marginBottom: 18 }}>
          Thank you for participating in our study!<br />
          We appreciate your time and effort.
        </div>
        <div style={{
          background: '#fff3e0',
          border: '1.5px solid #f57c00',
          borderRadius: 12,
          padding: '22px 18px',
          margin: '0 auto 18px auto',
          maxWidth: 380,
          textAlign: 'center',
          boxShadow: '0 2px 12px rgba(245, 124, 0, 0.08)',
          fontSize: 18,
          color: '#e65100',
          fontWeight: 600
        }}>
          <div style={{ marginBottom: 8 }}>Please copy and paste this task code:</div>
          <div style={{
            fontSize: 26,
            fontWeight: 800,
            letterSpacing: 2,
            color: '#d84315',
            background: '#fff',
            borderRadius: 8,
            padding: '10px 0',
            margin: '0 auto',
            width: '100%',
            boxShadow: '0 1px 4px rgba(245, 124, 0, 0.06)'
          }}>{INCOMPLETE_TASK_CODE}</div>
        </div>
        <div style={{ 
          fontSize: 15, 
          color: '#666', 
          marginTop: 8,
          background: '#f5f5f5',
          borderRadius: 8,
          padding: '12px 16px',
          border: '1px solid #e0e0e0'
        }}>
          <strong>Important:</strong> Please first return the task on Prolific. Then, message the researcher for compensation with this code and keep it for your records.
        </div>
        <div style={{ fontSize: 15, color: '#888', marginTop: 12 }}>
          {/* You may now close this window or return to Prolific to submit your code. */}
        </div>
      </div>
    </div>
  );
};

export default IncompleteThankYouPage; 